(function () {
  function setIcon(item, isOpen) {
    var v = item.querySelector('.cc-v');
    if (!v) return;
    v.style.opacity = isOpen ? '0' : '1';
    v.style.transform = isOpen ? 'translateX(-50%) scaleY(0)' : 'translateX(-50%)';
  }

  function openItem(item) {
    var panel = item.querySelector('.cc-panel');
    if (!panel) return;
    panel.style.height = panel.scrollHeight + 'px';
    item.classList.add('cc-open');
    var t = item.querySelector('.cc-trigger');
    if (t) t.setAttribute('aria-expanded', 'true');
    setIcon(item, true);
  }

  function closeItem(item) {
    var panel = item.querySelector('.cc-panel');
    if (!panel) return;
    panel.style.height = '0';
    item.classList.remove('cc-open');
    var t = item.querySelector('.cc-trigger');
    if (t) t.setAttribute('aria-expanded', 'false');
    setIcon(item, false);
  }

  function init() {
    var groups = document.querySelectorAll('.cc-accordion, [id^="ccAccordion"]');
    groups.forEach(function (group) {
      if (group.dataset.ccReady) return;
      group.dataset.ccReady = '1';
      var items = group.querySelectorAll('.cc-item');

      items.forEach(function (item) {
        var trigger = item.querySelector('.cc-trigger');
        var panel = item.querySelector('.cc-panel');
        if (!trigger || !panel) return;

        panel.style.overflow = 'hidden';
        panel.style.height = '0';
        panel.style.transition = 'height 0.3s ease';
        trigger.style.cursor = 'pointer';
        trigger.setAttribute('aria-expanded', 'false');

        trigger.addEventListener('click', function () {
          var wasOpen = item.classList.contains('cc-open');
          items.forEach(closeItem);
          if (!wasOpen) openItem(item);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();